export const TERMS_AND_CONDITIONS_URL = 'https://www.audiencerate.com/terms-and-conditions.pdf';
export const PRIVACY_POLICY_URL = 'https://audiencerate.com/privacy-mdp';
